import { useTranslation } from 'react-i18next';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import { type FinderVehicleFieldSectionProps, VehicleColumn } from '../shared';

const LocalizeValueSection = ({ labelPrefix, formPrefix }: FinderVehicleFieldSectionProps) => {
    const { t } = useTranslation('finderVehicle');

    return (
        <>
            <VehicleColumn>
                <FormFields.InputField
                    label={t(`${labelPrefix}Localize.label`)}
                    name={`${formPrefix}.localize`}
                    disabled
                />
            </VehicleColumn>
            <VehicleColumn>
                <FormFields.InputField label={t(`${labelPrefix}Value.label`)} name={`${formPrefix}.value`} disabled />
            </VehicleColumn>
        </>
    );
};

export default LocalizeValueSection;
